import type { SegmentData } from './transmuxerOp';
import type { TransmuxingResult, TransmuxingWorkerOp } from './transmuxingWorkerOp';
import { createUuid } from '@mimir/common/util/createUuid';
import type { TransmuxingRequest, TransmuxingResponse } from './transmuxingWebWorkerProtocol';


/**
 * This implementation delegates the transmuxing requests to a web worker.
 */
export class TransmuxingWebWorker implements TransmuxingWorkerOp {

  private callbacks: Record<string, (result: TransmuxingResult) => void> = {};
  private worker: Worker;

  constructor(audioOnly: boolean) {
    this.worker = audioOnly
      ? new Worker(new URL('./transmuxingProcessorAudioOnly.ts', import.meta.url), {
        type: 'module',
      })
      : new Worker(new URL('./transmuxingProcessor.ts', import.meta.url), {
        type: 'module',
      });
    this.worker.onmessage = (event: MessageEvent<TransmuxingResponse>) => {
      const message = event.data;

      const callback = this.callbacks[message.messageId];
      delete this.callbacks[message.messageId];
      if (callback) {
        callback(message.result);
      } else {
        console.error(`Unexpected message: ${JSON.stringify(message)}`);
      }
    };
  }


  post(
    flacDownmixMixMatrix: number[][],
    segmentToDecode: number,
    segments: SegmentData[],
    onResponse: (result: TransmuxingResult) => void,
  ) {
    const messageId = createUuid();
    this.callbacks[messageId] = onResponse;
    const request: TransmuxingRequest = {
      messageId,
      flacDownmixMixMatrix,
      segmentToDecode,
      segments,
    };
    this.worker.postMessage(request);
  }

  cleanup() {
    this.worker.terminate();
  }
}
